import {
    FLUSH,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
    REHYDRATE,
    persistReducer,
    persistStore
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { combineReducers, configureStore } from '@reduxjs/toolkit';

import useAccessToken from 'hooks/useAccessToken/state';
import useAccount from 'hooks/useAccount/state';
import useAircraft from 'hooks/useAircraft/state';
import useCurrentOrganization from 'hooks/useCurrentOrganization/state';
import useEaVision from 'hooks/useEaVision/state';
import useFieldView from 'hooks/useFieldView/state';
import useJohnDeere from 'hooks/useJohnDeere/state';
import useLogout from 'hooks/useLogout/state';
import useNavigation from 'hooks/useNavigation/state';
import useOAuth2 from 'hooks/useOAuth2/state';
import useOperators from 'hooks/useOperators/state';
import useOrganizations from 'hooks/useOrganizations/state';
import useQuickbooks from 'hooks/useQuickbooks/hooks/useQuickbooksConnection/state';
import useStripeSubscriptions from 'hooks/useStripeSubscriptions/state';
import useToast from 'hooks/useToast/state';
import useWorkOrder from 'hooks/useWorkOrder/state';

import useVerifyAccount from 'pages/VerifyAccountPage/hooks/useVerifyAccount/state';

const rootReducer = combineReducers({
    useAccessToken,
    useAccount,
    useAircraft,
    useCurrentOrganization,
    useEaVision,
    useFieldView,
    useJohnDeere,
    useLogout,
    useNavigation,
    useOAuth2,
    useOperators,
    useOrganizations,
    useQuickbooks,
    useStripeSubscriptions,
    useToast,
    useVerifyAccount,
    useWorkOrder
});

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['useCurrentOrganization', 'useJohnDeere', 'useOAuth2', 'useQuickbooks']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    'useWorkOrder/workOrder',
                    FLUSH,
                    REHYDRATE,
                    PAUSE,
                    PERSIST,
                    PURGE,
                    REGISTER
                ],

                ignoredPaths: ['useWorkOrder']
            }
        }),

    reducer: persistedReducer
});

export const persistor = persistStore(store);
